import { useMemo, useContext } from 'react'
import AuthContext from '../context/authContext'
import type { CurrentUserDateFormat } from '../lib/api/types/user.interfaces'
import {
	formatDocumentDate,
	formatDocumentDateTime,
} from '../lib/utils/formatDocument'

const DEFAULT_DATE_FORMAT: CurrentUserDateFormat = 'dd/MM/yyyy'

export function useUserDateFormat() {
	const { currentUser } = useContext(AuthContext)
	const dateFormat =
		currentUser?.profile?.preferences?.dateFormat ?? DEFAULT_DATE_FORMAT

	const formatDate = useMemo(
		() => (date: string | Date) => formatDocumentDate(date, dateFormat),
		[dateFormat],
	)
	const formatDateTime = useMemo(
		() => (date: string | Date) => formatDocumentDateTime(date, dateFormat),
		[dateFormat],
	)

	return { dateFormat, formatDate, formatDateTime }
}
